import React from 'react';
import {connect } from 'react-redux';
import {Link} from "react-router-dom";


function Copyright(props) {

    const year = new Date().getFullYear();

     const hideFrench = {
        display : (props.language === 'English') ? "none" : "block"
    }
    const hideEnglish = {
        display : (props.language === 'English') ? "block" : "none"
    }
   
    return (
            <>
            <div className="copyright" style={hideFrench}>&copy; {year} Visicom Media Inc. All Rights Reserved. <Link to="/privacy">Privacy Policy</Link></div>
            <div className="copyright" style={hideEnglish}>&copy; {year} Visicom Media Inc. Tous droits réservés. <Link to="/privacy">Politique de confidentialité</Link></div>
            </>
    );
}

const mapStateToProps = state => {
    return {
        language : state.language
    };
};

const mapDispatchToProps = dispatch => {
    return{
        onChangeLanguage: (language) => dispatch({ type: language })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Copyright);
